var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { USER_TYPE } from '../../constants/userConstants';
import getUserType from '../../utils/proxy-util/getUserType';
import isSns from '../../utils/proxy-util/isSns';
/**
 * 자동로그인 시 요청하여 얻은 응답결과를 TvingUser로 변환합니다.
 * @param NewTvingResponse<AppLoginBody>
 */
var proxyAppLogin = function (appLoginResponse) {
    var _a;
    var message = appLoginResponse.message, code = appLoginResponse.code, data = appLoginResponse.data;
    var _b = data || {}, custNo = _b.custNo, userId = _b.custId, tvingToken = _b.tvingToken, authToken = _b.authToken, userTypeValue = _b.custType, lastPasswordUpdateDate = _b.lastPasswordUpdateDate, cjOneMemberYn = _b.cjOneMembershipYn, realNameConfirmYn = _b.realNameConfirmYn, email = _b.email, accessToken = _b.accessToken, refreshToken = _b.refreshToken, regionCode = _b.regionCode;
    var userNo = custNo === null || custNo === void 0 ? void 0 : custNo.toString();
    var userType = userTypeValue ? getUserType(userTypeValue, cjOneMemberYn === 'Y') : USER_TYPE.TVING;
    var emailAddress;
    var emailVendor;
    if (email) {
        _a = __read(email.split('@'), 2), emailAddress = _a[0], emailVendor = _a[1];
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return {
        code: code,
        message: message,
        userToken: tvingToken,
        authToken: authToken,
        userNo: userNo,
        userId: userId,
        isSns: userType ? isSns(userType) : false,
        emailAddress: emailAddress,
        emailVendor: emailVendor,
        isRealNameConfirmed: realNameConfirmYn === 'Y',
        lastPasswordUpdateDate: lastPasswordUpdateDate,
        userType: userType,
        accessToken: accessToken,
        refreshToken: refreshToken,
        regionCode: regionCode,
    };
};
export default proxyAppLogin;
